"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const type_graphql_1 = require("type-graphql");
const typeorm_1 = require("typeorm");
const AccessKey_1 = require("./AccessKey");
const OsmosysBaseEntity_1 = require("../OsmosysBaseEntity");
const auth_1 = require("../auth");
const Workspace_1 = require("../auth/Workspace");
const class_validator_1 = require("class-validator");
const moment_timezone_1 = tslib_1.__importDefault(require("moment-timezone"));
// import moment from 'moment';
exports.TIMEZONES = moment_timezone_1.default.tz.names();
exports.INTEGRATION_NAMES = {
    ActiveCampaign: 'ActiveCampaign',
    CampaignMonitor: 'Campaign Monitor',
    ContentSystem: 'Content management system',
    Integration: 'Integration',
    Mailchimp: 'Mailchimp',
    Mailjet: 'Mailjet',
    Sailthru: 'Sailthru',
    Salesforce: 'Salesforce',
};
exports.INTEGRATION_TYPES = Object.keys(exports.INTEGRATION_NAMES);
exports.INTEGRATION_OPTIONS = Object.entries(exports.INTEGRATION_NAMES)
    .filter(([val]) => {
    return val !== 'Integration';
})
    .map(([value, label]) => {
    return {
        label,
        value,
    };
});
let Integration = class Integration extends OsmosysBaseEntity_1.OsmosysBaseEntity {
    constructor() {
        super(...arguments);
        this.isESP = false;
        this.integrationType = 'Integration';
        this.displayType = 'Integration';
        this.integrationTimezone = null;
    }
};
tslib_1.__decorate([
    type_graphql_1.Field(() => auth_1.User),
    typeorm_1.ManyToOne(() => auth_1.User, {
        cascade: true,
        nullable: true,
        onDelete: 'SET NULL',
    }),
    tslib_1.__metadata("design:type", Object)
], Integration.prototype, "creatingUser", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(),
    typeorm_1.Column({
        default: '',
    }),
    tslib_1.__metadata("design:type", String)
], Integration.prototype, "name", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(),
    typeorm_1.Column({
        default: '',
    }),
    tslib_1.__metadata("design:type", String)
], Integration.prototype, "description", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => Workspace_1.Workspace),
    typeorm_1.ManyToOne(() => Workspace_1.Workspace, workspace => workspace.integrations),
    typeorm_1.JoinColumn(),
    tslib_1.__metadata("design:type", Object)
], Integration.prototype, "workspace", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => Boolean),
    tslib_1.__metadata("design:type", Boolean)
], Integration.prototype, "isESP", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => String),
    tslib_1.__metadata("design:type", String)
], Integration.prototype, "integrationType", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => String),
    typeorm_1.Column('varchar'),
    tslib_1.__metadata("design:type", String)
], Integration.prototype, "type", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => String),
    tslib_1.__metadata("design:type", Object)
], Integration.prototype, "displayType", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => AccessKey_1.AccessKey, {
        nullable: true,
    }),
    typeorm_1.ManyToOne(() => AccessKey_1.AccessKey, {
        nullable: true,
        onDelete: 'SET NULL',
    }),
    tslib_1.__metadata("design:type", Object)
], Integration.prototype, "accessKey", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => String, { nullable: true }),
    class_validator_1.IsOptional(),
    class_validator_1.IsIn(exports.TIMEZONES),
    typeorm_1.Column('varchar', {
        name: 'integration_timezone',
    }),
    tslib_1.__metadata("design:type", Object)
], Integration.prototype, "integrationTimezone", void 0);
Integration = tslib_1.__decorate([
    type_graphql_1.ObjectType(),
    typeorm_1.Entity(),
    typeorm_1.TableInheritance({
        column: {
            name: 'type',
            type: 'varchar',
        },
    })
], Integration);
exports.Integration = Integration;
class IntegrationEntity extends Integration {
    toEndpoint() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return `/integrations/${this.id}`;
        });
    }
    toString() {
        return this.name;
    }
}
exports.IntegrationEntity = IntegrationEntity;
//# sourceMappingURL=Integration.js.map